import InlineComponent from './inlineComponent.jsx';
import Container from '../../../components/Container.jsx';

module.exports = class InlineContainer extends InlineComponent {
  define() {
    this.component = Container;
    this.data = {
      component: this.element.data('component'),
      componentProps: this.element.data('values'),
      messageOnEmpty: this.element.data('messageOnEmpty'),
      defaults: this.element.data('defaults') || {},
    };
  }
};
